<template>
  <!-- <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click.native="agree">Yes</v-btn>
        <v-btn color="grey" text @click.native="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
  <v-dialog v-model="dialog" persistent :max-width="options.width">
    <v-card style="background-color: #ffffff">
      <!-- <v-toolbar dark :color="options.color"> -->
      <v-toolbar color="#1972f5" light v-if="title">
        <div class="title2 white1">{{ title }}</div>
      </v-toolbar>
      <div class="message2">
        {{ message }}
      </div>
      <v-card-text></v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="cancel()" v-if="isConfirm">
          <div class="button2">{{ cancelBtn }}</div>
        </v-btn>
        <v-btn color="primary darken-1" text @click="agree()">
          <div class="button2">{{ okBtn }}</div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <dialogConfirm ref="confirm"></dialogConfirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <dialogConfirm ref="confirm"></dialogConfirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    isConfirm: null,
    okBtn: "OK",
    cancelBtn: "Cancel",
    options: {
      color: "red",
      width: 420,
      zIndex: 200,
    },
  }),
  methods: {
    openInfo(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.isConfirm = null;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    openConfirm(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.isConfirm = true;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    openConfirmWithButtons(title, message, options, okstr, cancelstr) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.isConfirm = true;
      this.options = Object.assign(this.options, options);
      this.okBtn = okstr;
      this.cancelBtn = cancelstr;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>



<style>
.message2 {
  display: inline-block;
  vertical-align: middle;
  line-height: 22px;
  padding-bottom: 10px;
  font-size: 14px;
  padding: 20px;
}

.title2 {
  /* padding: 20px 20px 0 20px; */
  font-size: 18px;
  font-weight: bold;
}
.button2 {
  font-size: 14px;
}
</style>